import BrandOwner from "./brandowner"
import Superadmin from "./superadmin"
import ChainStore from "./chainstore"
import Page404 from "../Page404";
import { useAuth } from "src/hooks/useAuth";
export default function OrderPage() {
  const {data} = useAuth();
  if (data.merchant_type === "brand") return <BrandOwner />;
  if (data?.user_type === "admin") return <Superadmin />;
  if (data.merchant_type === "shop" && data.store_category === 'chain_store') return <ChainStore />;
  return <Page404 />
}
